/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Dropoff_UnavailableInputs */

const en_dispatch_dropoff_unavailable = /** @type {(inputs: Dispatch_Dropoff_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No dropoff point on this world`)
};

const fr_dispatch_dropoff_unavailable = /** @type {(inputs: Dispatch_Dropoff_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun point de livraison sur ce world`)
};

const ms_sg2_dispatch_dropoff_unavailable = /** @type {(inputs: Dispatch_Dropoff_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada titik penghantaran di dunia ini`)
};

/**
* | output |
* | --- |
* | "No dropoff point on this world" |
*
* @param {Dispatch_Dropoff_UnavailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_dropoff_unavailable = /** @type {((inputs?: Dispatch_Dropoff_UnavailableInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Dropoff_UnavailableInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_dropoff_unavailable(inputs)
	if (locale === "fr") return fr_dispatch_dropoff_unavailable(inputs)
	return ms_sg2_dispatch_dropoff_unavailable(inputs)
});